import { motion, animate } from "framer-motion";
import { Building2, IndianRupee, TrendingUp } from "lucide-react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import { useEffect, useRef, useState, useMemo } from "react";
import axios from "axios";
import { apiurl } from "../config/config";

/* -------------------- UI PRIMITIVES -------------------- */
const Card = ({ children, className = "" }) => (
  <div className={`rounded-2xl bg-white shadow-lg p-6 ${className}`}>
    {children}
  </div>
);

const AnimatedNumber = ({ value }) => {
  const ref = useRef();
  useEffect(() => {
    const controls = animate(0, value || 0, {
      duration: 1.4,
      ease: "easeOut",
      onUpdate(v) {
        if (ref.current)
          ref.current.textContent = Math.floor(v).toLocaleString();
      },
    });
    return () => controls.stop();
  }, [value]);
  return <span ref={ref} />;
};

/* -------------------- DATA -------------------- */

let GMIT_Managers = ["JayVijay5099", "LavitBhati714", ""];
let ALTF_Managers = [
  "SanjayRewani1619",
  "ASHWANI3434",
  "Anand Suman 254",
  "Himanshu1203",
  "Abhishek4629",
];

const COLORS = ["#6366F1", "#22C55E", "#F97316", "#06B6D4"];
const BRAND = { primary: "#f97316", dark: "#000000" };

/* -------------------- DASHBOARD -------------------- */
export default function SalesDisplay() {
        const today = new Date().toISOString().split("T")[0];
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSales();
  }, []);

  const fetchSales = async () => {
    try {
      const res = await axios.get(`${apiurl}/utils/crm/realTimeOrderData`, {
        headers: {
          token: "ad2355a9d54335e27e2c3a3ed5b6e381",
          "Content-Type": "application/json",
        },
        params: {
          from_date: today,
          to_date: today,
        },
      });

      const api = res.data.data.result.data;
      console.log("API Response:", api);
      if (!api) return;

      // 🔹 Normalize API → UI format
      //   const normalized = {
      //     total: {
      //       orders: api.total.totalOrders,
      //       amount: Number(api.total.totalAmount),
      //       partial: Number(api.total.partialOrderCount),
      //       full: Number(api.total.fullOrderCount),
      //     },

      //     managers: api.managers.map((m) => ({
      //       id: m.o_manager_id,
      //       name: m.o_manager_name,
      //       orders: m.totalOrders,
      //       amount: Number(m.totalAmount),
      //       partial: Number(m.partialOrderCount),
      //       full: Number(m.fullOrderCount),
      //       partialPayment: Number(m.partialPayment),
      //       partialNetPayable: Number(m.partialNetPayable),
      //     })),
      //   };

      /* -------------------- MANAGER PHOTO MAP (ID → PHOTO) -------------------- */
      const managerPhotos = {
        5099: "https://cdn.yoursite.com/jayvijay.jpg",
        714: "https://cdn.yoursite.com/lavit.jpg",
        1619: "https://cdn.yoursite.com/sanjay.jpg",
      };

      const managers = api.managers.map((m) => ({
        id: m.o_manager_id,
        name: m.o_manager_name,
        orders: Number(m.totalOrders),
        amount: Number(m.totalAmount),
        partial: Number(m.partialOrderCount),
        full: Number(m.fullOrderCount),
        partialPayment: Number(m.partialPayment),
        partialNetPayable: Number(m.partialNetPayable),
        photo: managerPhotos[m.o_manager_id] || null,
      }));

      // 🔹 FLOOR SPLIT
      const gmitManagers = managers.filter((m) =>
        GMIT_Managers.includes(m.name)
      );

      const altfManagers = managers.filter((m) =>
        ALTF_Managers.includes(m.name)
      );

      // 🔹 FLOOR TOTALS
      const sum = (arr, key) =>
        arr.reduce((acc, cur) => acc + (cur[key] || 0), 0);

      const floors = {
        GMIT: {
          orders: sum(gmitManagers, "orders"),
          amount: sum(gmitManagers, "amount"),
        },
        ALTF: {
          orders: sum(altfManagers, "orders"),
          amount: sum(altfManagers, "amount"),
        },
      };

      const normalized = {
        total: {
          orders: Number(api.total.partialOrderCount),
          amount: Number(api.total.totalAmount),
          partial: Number(api.total.partialOrderCount),
          full: Number(api.total.fullOrderCount),
        },
        floors,
        managers,
      };

      setData(normalized);

      setData(normalized);
    } catch (err) {
      console.error("API Error:", err);
    } finally {
      setLoading(false);
    }
  };
  //   const fetchSales = async () => {
  //     try {
  //       const res = await axios.get(
  //         "https://crm.suwasthi.in/api/realTimeOrderData",
  //         {
  //           headers: {
  //             token: "ad2355a9d54335e27e2c3a3ed5b6e381",
  //             "Content-Type": "application/json",
  //           },
  //           params: {
  //             from_date: "2026-01-27",
  //             to_date: "2026-01-27",
  //           },
  //         }
  //       );

  //       const api = res.data?.result?.data;
  //       if (!api) return;

  //       // 🔹 Normalize API → UI format
  //       const normalized = {
  //         total: {
  //           orders: api.total.totalOrders,
  //           amount: Number(api.total.totalAmount),
  //           partial: Number(api.total.partialOrderCount),
  //           full: Number(api.total.fullOrderCount),
  //         },

  //         managers: api.managers.map((m) => ({
  //           id: m.o_manager_id,
  //           name: m.o_manager_name,
  //           orders: m.totalOrders,
  //           amount: Number(m.totalAmount),
  //           partial: Number(m.partialOrderCount),
  //           full: Number(m.fullOrderCount),
  //           partialPayment: Number(m.partialPayment),
  //           partialNetPayable: Number(m.partialNetPayable),
  //         })),
  //       };

  //       setData(normalized);
  //     } catch (err) {
  //       console.error("API Error:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  /* -------------------- MANAGER LOOKUP MAP (SAFE) -------------------- */
  const managerMap = useMemo(() => {
    if (!data?.managers) return {};
    return Object.fromEntries(data.managers.map((m) => [m.name, m]));
  }, [data]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-xl">
        Loading Sales Dashboard...
      </div>
    );
  }

  const ManagerTick = ({ x, y, payload }) => {
    if (!payload?.value) return null;

    const name = payload.value;
    const manager = managerMap[name];

    const photo = manager?.photo;
    const orders = manager?.orders ?? 0; // 👈 number from data

    return (
      <g transform={`translate(${x},${y + 10})`}>
        {/* Avatar */}
        <foreignObject x={-18} y={0} width={36} height={36}>
          {photo ? (
            <img
              src={photo}
              alt={name}
              className="w-9 h-9 rounded-full object-cover border"
            />
          ) : (
            <div
              className="w-9 h-9 rounded-full flex items-center justify-center text-white font-bold"
              style={{ backgroundColor: "#f97316" }}
            >
              {name.charAt(0)}
            </div>
          )}
        </foreignObject>

        {/* Name */}
        <text
          x={0}
          y={52}
          textAnchor="middle"
          fill="#000"
          fontSize={12}
          fontWeight={600}
        >
          {name.length > 10 ? `${name.slice(0, 10)}…` : name}
        </text>

        {/* 👇 NUMBER FROM DATA */}
        <text
          x={0}
          y={66}
          textAnchor="middle"
          fill="#f97316"
          fontSize={11}
          fontWeight={700}
        >
          {orders} orders
        </text>
      </g>
    );
  };

  const floorDonutData = [
    { name: "GMIT", value: data.floors.GMIT.orders },
    { name: "ALTF", value: data.floors.ALTF.orders },
  ];

  const managerDonutData = data.managers.map((m) => ({
    name: m.name,
    value: m.orders,
  }));

  const pieData = [
    { name: "Partial", value: data.total.partial },
    { name: "Full", value: data.total.full },
  ];

  const CenterText = ({ total }) => (
    <text
      x="50%"
      y="50%"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize="24"
      fontWeight="bold"
      fill="#000"
    >
      {total}
    </text>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-sky-50 to-emerald-50 px-10 py-8 space-y-10">
      {/* HEADER + TOTALS */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="flex flex-col md:flex-row md:items-center md:justify-between gap-6"
      >
        <div>
          <h1 className="text-4xl font-extrabold text-slate-800">
            Sales Dashboard
          </h1>
          <p className="text-slate-500">Real-Time Orders View</p>
        </div>

        <div className="grid grid-cols-3 gap-4">
          <Card className="bg-indigo-50 border border-indigo-200 text-center">
            <div className="text-xs text-indigo-600">Orders</div>
            <div className="text-2xl font-bold text-indigo-700">
              <AnimatedNumber value={data.total.orders} />
            </div>
          </Card>

          <Card className="bg-emerald-50 border border-emerald-200 text-center">
            <div className="text-xs text-emerald-600">Revenue</div>
            <div className="text-2xl font-bold text-emerald-700 flex justify-center items-center gap-1">
              <IndianRupee size={16} />
              <AnimatedNumber value={data.total.amount} />
            </div>
          </Card>

          <Card className="bg-orange-50 border border-orange-200">
            <ResponsiveContainer width="100%" height={70}>
              <PieChart>
                <Pie
                  data={pieData}
                  dataKey="value"
                  innerRadius={22}
                  outerRadius={30}
                  paddingAngle={4}
                >
                  {pieData.map((_, i) => (
                    <Cell key={i} fill={COLORS[i]} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </Card>
        </div>
      </motion.div>

      {/* FLOOR VS FLOOR */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
          {Object.entries(data.floors).map(([floor, f], idx) => (
            <motion.div
              key={floor}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <Card
                className={
                  idx === 0
                    ? "bg-gradient-to-br from-indigo-500 to-indigo-600 text-white"
                    : "bg-gradient-to-br from-emerald-500 to-emerald-600 text-white"
                }
              >
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-3xl font-bold flex items-center gap-2">
                    <Building2 /> {floor}
                  </h2>
                  <TrendingUp className="opacity-40" size={40} />
                </div>

                <div className="flex justify-between items-center mb-2">
                  <span className="opacity-80">Orders</span>
                  <span className="text-4xl font-extrabold">
                    <AnimatedNumber value={f.orders} />
                  </span>
                </div>

                <div className="flex justify-between items-center">
                  <span className="opacity-80">Revenue</span>
                  <span className="text-3xl font-bold">
                    ₹ <AnimatedNumber value={f.amount} />
                  </span>
                </div>
              </Card>
            </motion.div>
          ))}
        </div>
        <Card>
          <h3 className="text-xl font-bold mb-4">Floor Wise Orders</h3>

          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={floorDonutData}
                dataKey="value"
                nameKey="name"
                innerRadius={70}
                outerRadius={110}
                paddingAngle={4}
              >
                <Cell fill="#f97316" /> {/* GMIT */}
                <Cell fill="#000000" /> {/* ALTF */}
                <CenterText
                  total={managerDonutData.reduce((a, b) => a + b.value, 0)}
                />
              </Pie>

              <Tooltip />
            </PieChart>
          </ResponsiveContainer>

          {/* LEGEND */}
          <div className="flex justify-center gap-6 mt-4">
            <div className="flex items-center gap-2">
              <span className="w-3 h-3 rounded-full bg-[#f97316]" />
              GMIT
            </div>
            <div className="flex items-center gap-2">
              <span className="w-3 h-3 rounded-full bg-black" />
              ALTF
            </div>
          </div>
        </Card>
      </div>

      <BarChart
        data={Object.entries(data.floors).map(([floor, f]) => ({
          floor,
          orders: f.orders,
        }))}
      >
        <XAxis dataKey="floor" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="orders" fill="#6366F1" radius={[12, 12, 0, 0]} />
      </BarChart>
      <Card>
        <h3 className="text-xl font-bold mb-4">Manager Orders</h3>
        <ResponsiveContainer width="100%" height={350}>
          <BarChart data={data.managers} margin={{ bottom: 80 }}>
            <XAxis dataKey="name" tick={<ManagerTick />} interval={0} />
            <YAxis />
            <Tooltip />
            <Bar
              dataKey="orders"
              fill={BRAND.primary}
              radius={[10, 10, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </Card>

      <Card>
        <h3 className="text-xl font-bold mb-4">Manager Wise Orders</h3>

        <ResponsiveContainer width="100%" height={350}>
          <PieChart>
            <Pie
              data={managerDonutData}
              dataKey="value"
              nameKey="name"
              innerRadius={80}
              outerRadius={130}
              paddingAngle={3}
            >
              {managerDonutData.map((_, index) => (
                <Cell
                  key={index}
                  fill={index % 2 === 0 ? "#f97316" : "#000000"}
                />
              ))}
              <CenterText
                total={managerDonutData.reduce((a, b) => a + b.value, 0)}
              />
            </Pie>

            <Tooltip formatter={(value, name) => [`${value} Orders`, name]} />
          </PieChart>
        </ResponsiveContainer>
      </Card>

      {/* MANAGER WISE SECTION */}
      <Card>
        <h3 className="text-2xl font-bold mb-6" style={{ color: BRAND.dark }}>
          Manager Wise Performance
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {data.managers.map((m) => (
            <motion.div
              key={m.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <div className="rounded-2xl border p-6 shadow-md bg-gradient-to-br from-orange-50 to-white">
                {/* HEADER */}
                <div className="flex justify-between items-center mb-4">
                  <div>
                    <h4 className="text-xl font-bold text-black">{m.name}</h4>
                    <p className="text-sm text-gray-500">ID: {m.id}</p>
                  </div>
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center text-white font-bold"
                    style={{ backgroundColor: BRAND.primary }}
                  >
                    {m.name.charAt(0)}
                  </div>
                </div>

                {/* METRICS */}
                <div className="space-y-2">
                  <div className="flex justify-between">
                    <span className="text-gray-500">Orders</span>
                    <span className="font-bold text-black">{m.orders}</span>
                  </div>

                  <div className="flex justify-between">
                    <span className="text-gray-500">Amount</span>
                    <span className="font-bold text-black">
                      ₹ {m.amount.toLocaleString()}
                    </span>
                  </div>

                  <div className="flex justify-between">
                    <span className="text-gray-500">Collected</span>
                    <span className="font-bold text-green-700">
                      ₹ {m.partialPayment.toLocaleString()}
                    </span>
                  </div>

                  <div className="flex justify-between">
                    <span className="text-gray-500">Pending</span>
                    <span className="font-bold text-red-600">
                      ₹ {m.partialNetPayable.toLocaleString()}
                    </span>
                  </div>
                </div>

                {/* PARTIAL / FULL */}
                <div className="mt-4 grid grid-cols-2 gap-3">
                  <div className="rounded-xl p-3 text-center bg-orange-100">
                    <div className="text-xs text-orange-700">Partial</div>
                    <div className="text-lg font-bold text-orange-800">
                      {m.partial}
                    </div>
                  </div>

                  <div className="rounded-xl p-3 text-center bg-black text-white">
                    <div className="text-xs opacity-80">Full</div>
                    <div className="text-lg font-bold">{m.full}</div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </Card>
    </div>
  );
}